import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import Popper from '@di-shared/features/common/Popper';

function MileageLimitOdomterTooltip() {
  const {t} = useInferableTranslation();

  return (
    <Popper
      placement="bottom"
      className="tooltip"
      marginLeft={3}
      tooltip={
        <>
          <strong className="tooltip_title">{t('T30250')}</strong>
          <ul className="tooltip_list">
            <li className="tooltip_item">{t('T30251')}</li>
            <li className="tooltip_item">{t('T30252')}</li>
          </ul>
        </>
      }
    >
      <div className="tooltip_area tooltip_area_single">
        <button
          aria-describedby="tooltipBox01"
          className="btn_tooltip"
          type="button"
          aria-controls="tooltipStatement01"
          aria-expanded="false"
        >
          <span
            className="ic ic_information_16px"
            aria-hidden="true"
          />
          <span className="blind">{t('T10044')}</span>
        </button>
      </div>
    </Popper>
  );
}

export default MileageLimitOdomterTooltip;
